import React from 'react';
import i18n from 'i18next';
import './NoClient.css';

const NoClient = () => (
  <div className="no-client">
    <span>{i18n.t('common:NoClient')}</span>
  </div>
);

export default NoClient;



// WEBPACK FOOTER //
// ./src/components/NoClient/NoClient.jsx